import { formatName } from 'components/Charts/Utils/benchmarks';
import moment from 'moment';

export const startPeriod = 'Start of data';
export const maxDate = moment().subtract(1, 'days').format('DD/MM/YYYY');

export const getStartDate = (period: string) => {
  if (period === startPeriod) {
    return moment('01/01/1800', 'DD/MM/YYYY');
  }
  const number = (period.match(/\d+/gm) || ['5'])[0] as string;
  const type = ({ m: 'month', y: 'year' } as any)[
    number ? period.split(number)[1] : 'y'
  ];
  return moment(maxDate, 'DD/MM/YYYY')
    .subtract(Number(number), type)
    .add(1, 'days');
};

export const getAllPerformanceData = (data: any) => {
  data = data || [{}];
  const keys = Object.keys(data || {}).filter((key: string) => key !== 'date');
  const cumulative = [
    { time: 3, period: 'month' },
    { time: 6, period: 'month' },
    { time: 1, period: 'year' },
    { time: 3, period: 'year' },
    { time: 5, period: 'year' }
  ];
  const discrete = Array(5).fill(0);
  const annualised = [1, 3, 5];
  const calendar = Array.from({ length: 5 }, (_, i) =>
    moment()
      .subtract(i + 1, 'year')
      .year()
  );

  return {
    cumulative: keys.reduce(
      (acc: any, curr: string) => (
        (acc[formatName(curr)] = cumulative.map(
          item =>
            data[curr][`cumulative_${item.time}${item.period}_performance`]
        )),
        acc
      ),
      {}
    ),
    discrete: keys.reduce(
      (acc: any, curr: string) => (
        (acc[formatName(curr)] = discrete.map((item, index: number) => {
          return data[curr][`discrete_${index}_performance`];
        })),
        acc
      ),
      {}
    ),
    annualised: keys.reduce(
      (acc: any, curr: string) => (
        (acc[formatName(curr)] = annualised.map(
          (number: number) => data[curr][`annualised_${number}year_performance`]
        )),
        acc
      ),
      {}
    ),
    calendar: keys.reduce(
      (acc: any, curr: string) => (
        (acc[formatName(curr)] = calendar.map(
          (year: number, index: number) =>
            data[curr][`calendar_${index}_performance`]
        )),
        acc
      ),
      {}
    )
  };
};
